/* theme-motion.js — hero carousel and logo marquee.
   Loaded by sections/hero-carousel.liquid, sections/collection-hero.liquid and
   sections/marquee.liquid, so pages without either never download it. */
(function () {
  'use strict';

  if (window.__tsMotionLoaded) return;
  window.__tsMotionLoaded = true;

/* ---------- hero carousel ---------- */
  function initHero(hero) {
    if (hero.dataset.tsHeroInit) return;
    hero.dataset.tsHeroInit = '1';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-slide]'));
    var texts = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-text]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-ts-hero-dot]'));
    if (slides.length <= 1) return;
    var idx = 0, timer;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      texts.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    function start() { timer = setInterval(function () { go(idx + 1); }, 5000); }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { stop(); go(n); start(); });
    });
    go(0); start();
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    /* The theme editor removes the section's DOM but the interval would keep
       firing against detached nodes until the page reloads. */
    hero._tsStop = stop;
  }

/* Duplicate until each half overflows, or the -50% CSS loop jumps. */
  function fillMarquee(track) {
    var copies = Array.prototype.slice.call(track.querySelectorAll('.ts-marquee-copy'));
    if (copies.length !== 2) return;
    var baseline = track.dataset.tsMarqueeBase;
    if (!baseline) { baseline = copies[0].innerHTML; track.dataset.tsMarqueeBase = baseline; }
    copies.forEach(function (c) { c.innerHTML = baseline; });
    var need = (track.parentElement || track).clientWidth;
    var unit = copies[0].scrollWidth;
    if (!unit || !need) return;
    var reps = Math.max(1, Math.ceil(need / unit));
    if (reps > 1) {
      var html = '';
      for (var i = 0; i < reps; i++) html += baseline;
      copies.forEach(function (c) { c.innerHTML = html; });
    }
    /* Keep perceived speed constant regardless of how much content was added */
    var secondsPerPass = parseFloat(track.dataset.tsMarqueeSpeed || track.style.animationDuration) || 32;
    track.style.animationDuration = (secondsPerPass * reps) + 's';
    if (!track.dataset.tsMarqueeSpeed) track.dataset.tsMarqueeSpeed = String(secondsPerPass);
  }

  var marqueeResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeResizeTimer);
    marqueeResizeTimer = setTimeout(function () {
      document.querySelectorAll('.ts-marquee-track').forEach(fillMarquee);
    }, 150);
  });


  function boot() {
    document.querySelectorAll('[data-ts-hero]').forEach(initHero);
    document.querySelectorAll('.ts-marquee-track').forEach(fillMarquee);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-ts-hero]').forEach(function (hero) {
      if (typeof hero._tsStop === 'function') hero._tsStop();
    });
  });
})();
